import * as React from 'react';

import { SidebarContext } from './SidebarContext';

export function useSidebar() {
  const context = React.use(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider.');
  }

  return context;
}
